const stationLabel = (station) =>
	station?.name ? `${station.code} - ${station.name}` : (station?.code ?? '');

/**
 * Formats a ride's autocomplete-option title.
 *
 * Shows the first and last stations only (`first → last`), even for
 * multi-leg rides. Full station chains can be dozens of stops long and
 * would blow up the row height; the terminal endpoints are the useful
 * signal in a picker.
 *
 * Example:
 *   `TN 2312 / LN1000: DNV6 - Denver → TRN6 - Toronto`
 *
 * Each station renders as `<code> - <name>` when a name is present and
 * falls back to the code alone otherwise. If the ride has no trip
 * metadata, falls through to the route alone, then to `ride.id`.
 */
export const rideOptionTitle = (ride) => {
	const prefix = [ride.tripNumber && `TN ${ride.tripNumber}`, ride.lineCode && `LN${ride.lineCode}`]
		.filter(Boolean)
		.join(' / ');
	const stations = ride.stations ?? [];
	const first = stations[0];
	const last = stations[stations.length - 1];
	const route =
		first && last && first !== last
			? [stationLabel(first), stationLabel(last)].filter(Boolean).join(' → ')
			: stationLabel(first);
	if (prefix && route) return `${prefix}: ${route}`;
	return prefix || route || ride.id;
};
